<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-section-title__param-container">
    <div class="common-section-title__param-inner-container">
      <div class="common-section-title__param-band-field">
        <div class="common-section-title__param-title-band-container">
          <div [ngClass]="{'common-section-title__param-label-icons-container': !customizeField.field.editableName,
            'common-section-title__param-input-icons-container': customizeField.field.editableName && !customizeField.field.error,
            'common-section-title__param-input-icons-container-error': customizeField.field.editableName && customizeField.field.error}">
            <i [class]="'common-icon__md ' + customizeField.field.icon"></i>
            @if(customizeField.field.editableName){
              <input type="text"
                [id]="'field-modal-'+customizeField.field.id"
                class="common-section-title__param-input-group"
                [(ngModel)]="customizeField.field.label"
                pAutoFocus
                [autofocus]="customizeField.field.editableName"
                maxlength="150"
                (keyup)="checkErrorLabel(customizeField.field)"
                (blur)="changeEditableField(customizeField.field, $event)">
            }@else {
              <span-tooltip class="common-section-title__param-label-band"
                [text]="customizeField.field.label"></span-tooltip>
            }
          </div>
        </div>
        @if(customizeField.field.editableName){
          <button class="common-button__icon-md-noborder"
            (click)="changeEditableField(customizeField.field, $event)"
            [disabled]="customizeField.field.error">
              <i class="lf-icon-check common-icon__md"></i>
          </button>
        }@else {
          <button class="common-button__icon-md-noborder"
            (click)="customizeField.field.editableName = !customizeField.field.editableName"
            [disabled]="configuration.concept?.disabled">
              <i class="lf-icon-edit common-icon__md"></i>
          </button>
        }
      </div>
    </div>
    <!-- @if(customizeField.field.error){
      <div class="common-section-title__param-error-container">
        <span [afTranslate]="'common.field-mandatory'">_Campo obligatorio</span>
      </div>
    } -->
  </div>
  <!-- Contenedor -->
  <customize-fields class="common-modal__content-scroll"
    [field]="customizeField.field"
    [hiddenHeader]="true"
    [actionType]="configuration.actionType"
    [fieldContainer]="configuration.fieldContainer"
    [isPrivate]="configuration.isPrivate"
    [hiddenInLandings]="configuration.hiddenInLandings"
    [concept]="configuration.concept"
    [visibilityItems]="configuration.visibilityItems"
    (launchAction)="emitAction($event)">
  </customize-fields>
  <!-- Footer botonera -->
  <div class="common-modal__footer">
    @if(configuration.actionType === 'edit' && !configuration.concept.hasInstances){
      <button class="common-button__text-noborder"
        (click)="deleteField()">
        <span class="common-button__text-title"
          [afTranslate]="'expanded-menu.delete-field'">_Eliminar campo</span>
      </button>
    }
    <button class="common-button__text-border"
      (click)="handleDismiss()">
      <span class="common-button__text-title"
        [afTranslate]="'common.cancel'">_Cancelar</span>
    </button>
    <button class="common-button__text"
      (click)="saveField()">
      <span class="common-button__text-title"
        [afTranslate]="'common.save'">_Guardar</span>
    </button>
  </div>
</div>
